import { RemToPx } from 'smg/util';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const $featuredProductsContainers = document.querySelectorAll<HTMLElement>('.home-featured-products-container');

$featuredProductsContainers.forEach($featuredProductsContainer => {
    const $featuredProducts = $featuredProductsContainer.querySelector('.swiper') as HTMLElement;

    new Swiper($featuredProducts, {
        modules: [Navigation, Pagination, Autoplay],

        loop: true,
        autoplay: true,

        slidesPerView: 1,
        spaceBetween: RemToPx(2),
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1400: {
                slidesPerView: 4,
            },
        },

        observeParents: true,
        observeSlideChildren: true,
        observer: true,

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            addIcons: false,
        },
    });
});

const $featuredBrandsContainers = document.querySelectorAll<HTMLElement>('.home-featured-brands-container');
$featuredBrandsContainers.forEach($featuredBrandsContainer => {
    const $featuredBrands = $featuredBrandsContainer.querySelector('.swiper') as HTMLElement;

    const $prevButton = $featuredBrandsContainer.querySelector<HTMLElement>('.swiper-button-prev');
    const $nextButton = $featuredBrandsContainer.querySelector<HTMLElement>('.swiper-button-next');
    const $pagination = $featuredBrandsContainer.querySelector<HTMLElement>('.swiper-pagination');

    new Swiper($featuredBrands, {
        modules: [Navigation, Pagination, Autoplay],

        loop: true,
        autoplay: true,
        watchOverflow: true,

        slidesPerView: 3,
        spaceBetween: RemToPx(1),
        breakpoints: {
            576: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 5,
            },
            992: {
                slidesPerView: 6,
            },
            1200: {
                slidesPerView: 8,
            },
            1400: {
                slidesPerView: 10,
            },
        },

        observeParents: true,
        observeSlideChildren: true,
        observer: true,

        pagination: {
            el: $pagination,
            clickable: true,
        },

        navigation: {
            nextEl: $nextButton,
            prevEl: $prevButton,
            addIcons: false,
        },
    });
});